






import Vue from 'vue';

export default Vue.extend({
  name: "StadiumMain2d",
  data: () => {
    return {};
  },
});
